export const PLAYER_MOVE_INIT = 'PLAYER_MOVE_INIT';
export const PLAYER_MOVE_SHOW_CITIES = 'PLAYER_MOVE_SHOW_CITIES';
export const PLAYER_MOVE_TO_CITY = 'PLAYER_MOVE_TO_CITY';
export const PLAYER_MOVE_CANCEL = 'PLAYER_MOVE_CANCEL';
export const PLAYER_MOVE_COMPLETE = 'PLAYER_MOVE_COMPLETE';

export const PLAYER_BUILD_STATION = 'PLAYER_BUILD_STATION';

export const PLAYER_TREAT_DISEASE = 'PLAYER_TREAT_DISEASE';
export const PLAYER_TREAT_ALL_DISEASE = 'PLAYER_TREAT_ALL_DISEASE';
export const PLAYER_CURE_DISEASE_INIT = 'PLAYER_CURE_DISEASE_INIT';
export const PLAYER_CURE_DISEASE_SHOW_CARDS = 'PLAYER_CURE_DISEASE_SHOW_CARDS';
export const PLAYER_CURE_DISEASE_CANCEL = 'PLAYER_CURE_DISEASE_CANCEL';
export const PLAYER_CURE_DISEASE_COMPLETE = 'PLAYER_CURE_DISEASE_COMPLETE';
export const PLAYER_SHARE_INIT = 'PLAYER_SHARE_INIT';
export const PLAYER_SHARE_SHOW_CANDIDATES = 'PLAYER_SHARE_SHOW_CANDIDATES';
export const PLAYER_SHARE_CARD = 'PLAYER_SHARE_CARD';
export const PLAYER_SHARE_CANCEL = 'PLAYER_SHARE_CANCEL';

export const PLAYER_PLAY_EVENT_INIT = 'PLAYER_PLAY_EVENT_INIT';

export const EVENT_ONE_QUIET_NIGHT_SKIP = 'EVENT_ONE_QUIET_NIGHT_SKIP';
export const EVENT_GOV_GRANT_SHOW_CITIES = 'EVENT_GOV_GRANT_SHOW_CITIES';
export const EVENT_GOV_GRANT_BUILD_STATION = 'EVENT_GOV_GRANT_BUILD_STATION';
export const EVENT_FORECAST_SHOW_CARDS = 'EVENT_FORECAST_SHOW_CARDS';
export const EVENT_FORECAST_SHUFFLE = 'EVENT_FORECAST_SHUFFLE';
export const EVENT_RES_POP_REMOVE_CARD = 'EVENT_RES_POP_REMOVE_CARD';
export const EVENT_RES_POP_SUGGEST = 'EVENT_RES_POP_SUGGEST';
export const EVENT_AIRLIFT_CHOOSE_PLAYER = 'EVENT_AIRLIFT_CHOOSE_PLAYER';
export const EVENT_AIRLIFT_SHOW_CITIES = 'EVENT_AIRLIFT_SHOW_CITIES';
export const EVENT_AIRLIFT_MOVE_TO_CITY = 'EVENT_AIRLIFT_MOVE_TO_CITY';

export const MEDIC_TREAT_CURED_DISEASES = 'MEDIC_TREAT_CURED_DISEASES';
export const MEDIC_PREVENT_INFECTION = 'MEDIC_PREVENT_INFECTION';

export const OPS_SHOW_CARDS_TO_DISCARD = 'OPS_SHOW_CARDS_TO_DISCARD';
export const OPS_CHOOSE_CARD_TO_DISCARD = 'OPS_CHOOSE_CARD_TO_DISCARD';

export const CONT_PLANNER_INIT = 'CONT_PLANNER_INIT';
export const CONT_PLANNER_SHOW_EVENTS_FROM_DISCARD = 'CONT_PLANNER_SHOW_EVENTS_FROM_DISCARD';
export const CONT_PLANNER_CHOOSE_EVENT = 'CONT_PLANNER_CHOOSE_EVENT';
export const CONT_PLANNER_EVENT_COMPLETE = 'CONT_PLANNER_EVENT_COMPLETE';

export const QUAR_SPEC_PREVENT_INFECTION = 'QUAR_SPEC_PREVENT_INFECTION';

export const DISPATCHER_CHOOSE_PLAYER = 'DISPATCHER_CHOOSE_PLAYER';
export const DISPATCHER_SHOW_CITIES = 'DISPATCHER_SHOW_CITIES';

export const ERADICATE_DISEASE = 'ERADICATE_DISEASE';

export const CARD_DISCARD_FROM_HAND_INIT = 'CARD_DISCARD_FROM_HAND_INIT';
export const CARD_DRAW_CARDS_INIT = 'CARD_DRAW_CARDS_INIT';
export const CARD_DRAW_CARDS_HANDLE_INIT = 'CARD_DRAW_CARDS_HANDLE_INIT';
export const CARD_DRAW_CARDS_HANDLE = 'CARD_DRAW_CARDS_HANDLE';
export const CARD_DISCARD_FROM_INFECTION_DECK_BOTTOM = 'CARD_DISCARD_FROM_INFECTION_DECK_BOTTOM';
export const CARD_DISCARD_FROM_INFECTION_DECK_TOP = 'CARD_DISCARD_FROM_INFECTION_DECK_TOP';
export const CARD_OVER_LIMIT_DISCARD_INIT = 'CARD_OVER_LIMIT_DISCARD_INIT';
export const CARD_OVER_LIMIT_DISCARD_COMPLETE = 'CARD_OVER_LIMIT_DISCARD_COMPLETE';
export const CARD_DRAW_INFECTION_CARD = 'CARD_DRAW_INFECTION_CARD';

export const OUTBREAK_INIT = 'OUTBREAK_INIT';
export const INFECT_CITY = 'INFECT_CITY';
export const INFECT_NEIGHBOR = 'INFECT_NEIGHBOR';
export const OUTBREAK_COMPLETE = 'OUTBREAK_COMPLETE';
export const OUTBREAK_QUEUE = 'OUTBREAK_QUEUE';
export const INFECT_CITIES = 'INFECT_CITIES';

export const USE_DISEASE_CUBES = 'USE_DISEASE_CUBES';

export const EPIDEMIC_INCREASE = 'EPIDEMIC_INCREASE';
export const EPIDEMIC_INFECT_INIT = 'EPIDEMIC_INFECT_INIT';
export const EPIDEMIC_INTENSIFY_INIT = 'EPIDEMIC_INTENSIFY_INIT';
export const EPIDEMIC_INTENSIFY_CONTINUE = 'EPIDEMIC_INTENSIFY_CONTINUE';
export const EPIDEMIC_INTENSIFY = 'EPIDEMIC_INTENSIFY';

export const ANIMATION_MOVE_COMPLETE = 'ANIMATION_MOVE_COMPLETE';
export const ANIMATION_DRAW_CARDS_INIT_COMPLETE = 'ANIMATION_DRAW_CARDS_INIT_COMPLETE';
export const ANIMATION_DRAW_INFECTION_CARD_COMPLETE = 'ANIMATION_DRAW_INFECTION_CARD_COMPLETE';
export const ANIMATION_INFECT_NEIGHBOR_COMPLETE = 'ANIMATION_INFECT_NEIGHBOR_COMPLETE';
export const ANIMATION_DEAL_CARDS_INIT_COMPLETE = 'ANIMATION_DEAL_CARDS_INIT_COMPLETE';
export const ANIMATION_DEAL_CARDS_COMPLETE = 'ANIMATION_DEAL_CARDS_COMPLETE';
export const ANIMATION_INSERT_EPIDEMIC_CARDS_COMPLETE = 'ANIMATION_INSERT_EPIDEMIC_CARDS_COMPLETE';
export const ANIMATION_CARD_DISCARD_FROM_HAND_COMPLETE = 'ANIMATION_CARD_DISCARD_FROM_HAND_COMPLETE';
export const ANIMATION_EPIDEMIC_INFECT_COMPLETE = 'ANIMATION_EPIDEMIC_INFECT_COMPLETE';
export const ANIMATION_CURE_DISEASE_COMPLETE = 'ANIMATION_CURE_DISEASE_COMPLETE';

export const CREATE_QUICK_GAME_INIT = 'CREATE_QUICK_GAME_INIT';
export const CREATE_CUSTOM_GAME_INIT = 'CREATE_CUSTOM_GAME_INIT';
export const CREATE_GAME = 'CREATE_GAME';
export const DEAL_CARDS_INIT = 'DEAL_CARDS_INIT';
export const DEAL_CARDS = 'DEAL_CARDS';
export const INSERT_EPIDEMIC_CARDS_INIT = 'INSERT_EPIDEMIC_CARDS_INIT';
export const INSERT_PLAYER_CARD = 'INSERT_PLAYER_CARD';
export const START_GAME = 'START_GAME';
export const PASS_TURN = 'PASS_TURN';
export const VICTORY = 'VICTORY';
export const DEFEAT = 'DEFEAT';
export const CONTINUE = 'CONTINUE';

export const ACTIONS = [PLAYER_MOVE_COMPLETE, PLAYER_BUILD_STATION, ANIMATION_CURE_DISEASE_COMPLETE, PLAYER_TREAT_DISEASE,
  PLAYER_TREAT_ALL_DISEASE, PLAYER_SHARE_CARD, CONT_PLANNER_CHOOSE_EVENT];



/** WEBPACK FOOTER **
 ** ./src/constants/actionTypes.js
 **/